import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGnuComponent } from './simple-icons-gnu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGnuComponent ],
    exports:      [ SimpleIconsGnuComponent ],
    bootstrap:    []
})
export class SimpleIconsGnuModule {}
